import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { Overlay } from "../overlay/overlay.es.js";
const eitherPropIsRequired = (props, propName, componentName) => {
  const { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby } = props;
  if (ariaLabel === void 0 && ariaLabelledby === void 0) {
    return new Error(
      // eslint-disable-next-line max-len
      `Either the prop \`aria-label\` or the prop \`aria-labelledby\` is marked as required in \`${componentName}\`.`
    );
  }
  return null;
};
const propTypes = {
  animation: PropTypes.bool,
  "aria-label": eitherPropIsRequired,
  "aria-labelledby": eitherPropIsRequired,
  children: PropTypes.node,
  closeOnOverlayClick: PropTypes.bool,
  height: PropTypes.number,
  minHeight: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  width: PropTypes.number
};
const defaultProps = {
  animation: true,
  "aria-label": void 0,
  "aria-labelledby": void 0,
  children: void 0,
  closeOnOverlayClick: true,
  height: void 0,
  minHeight: 0,
  width: 400
};
const Modal = ({
  animation,
  "aria-label": ariaLabel,
  "aria-labelledby": ariaLabelledby,
  children,
  closeOnOverlayClick,
  height,
  minHeight,
  onClose,
  width,
  ...restProps
}) => /* @__PURE__ */ jsx(
  Overlay,
  {
    animation,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    height,
    minHeight,
    closeOnOverlayClick,
    onClose,
    role: "presentation",
    width,
    ...restProps,
    children
  }
);
Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
export {
  Modal
};
